import React, { useState, useRef, useEffect } from 'react';

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  const dropdownItems = [
    { icon: "fas fa-user", label: "My Profile", className: "profile" },
    { icon: "fas fa-bookmark", label: "Saved Tutors", className: "saved" },
    { icon: "fas fa-comments", label: "Messages", className: "messages" },
    { icon: "fas fa-cog", label: "Settings", className: "settings" },
    { icon: "fas fa-question-circle", label: "Help & Support", className: "help" },
    { icon: "fas fa-sign-out-alt", label: "Logout", className: "logout" }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && triggerRef.current &&
          !dropdownRef.current.contains(event.target) &&
          !triggerRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="header-container">
      <header className="header-section">
        <h1 className="header-title">Find Your Tutor</h1>
        <p>Browse highly qualified tutors based on location and subjects in list view.</p>
      </header>

      <div className="profile-section">
        <div 
          className="profile-trigger" 
          id="profileTrigger"
          ref={triggerRef}
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen(!dropdownOpen);
          }}
        >
          <div className="profile-avatar">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=100&h=100&auto=format&fit=crop" alt="User Avatar" />
          </div>
          <div className="profile-info">
            <div className="profile-name">shahensa</div>
            <div className="profile-role">Premium Member</div>
          </div>
          <i className="fas fa-chevron-down"></i>
        </div>
        <div 
          className={`profile-dropdown ${dropdownOpen ? 'active' : ''}`} 
          id="profileDropdown"
          ref={dropdownRef}
        >
          {dropdownItems.map((item, index) => (
            <React.Fragment key={index}>
              {index === 4 && <div className="dropdown-divider"></div>}
              <div className={`dropdown-item ${item.className}`}>
                <i className={item.icon}></i>
                <span>{item.label}</span>
              </div>
              {index === 3 && <div className="dropdown-divider"></div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Header;